import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Select from 'react-select/creatable';
import { useClients } from '~/hooks/clients';
import { useOrders } from '~/hooks/orders';
import { useCartCompany } from '../../../../hooks/cartCompany';
import Cart from '../Cart';

import {
  Container,
  TabsContainer,
  Tabs,
  TabItem,
  CartFloatButton,
  Overlay,
} from './styles';
import { clearFormatPhoneNumber } from '~/utils/getPhoneFormatted';

import { ClientFormModal } from '~/pages/company/ClientForm/ClientFormModal';
import { useSettings } from '~/hooks/settings';
import IDistance from '~/interfaces/IDistance';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import { useAuth } from '~/hooks/auth';
import { PauseOrderButton } from '~/components/Backorders/PauseOrderButton';
import { getAddressClientPOS } from '~/utils/getAddressClientPOS';

const OrderDetails: React.FC = () => {
  const {
    products,
    openModalCart,
    setOpenModalCart,
    tables,
    loadTables,
    setTableSelected,
    tableSelected,
  } = useCartCompany();
  const { clients, loadClients, setSelectedClient, newClient, selectedClient } =
    useClients();

  const { distances, loadDistances } = useSettings();

  const { company } = useAuth();

  const [init, setInit] = useState(false);
  const { loadOrdersTable, orderTables } = useOrders();
  const [initTable, setInitTable] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [search, setSearch] = useState('');

  const [toggleAddres, setToggleAddres] = useState(false);

  const [selectedClientDistance, setSelectedClientDistance] = useState(
    {} as IDistance,
  );

  useEffect(() => {
    if (distances === null && company.uid) {
      loadDistances(company.uid);
    }
  }, [distances, company, loadDistances]);

  useEffect(() => {
    loadOrdersTable();
  }, [loadOrdersTable]);

  useEffect(() => {
    setInit(true);
    if (!init) loadClients();
  }, [loadClients, init]);

  useEffect(() => {
    const bairro = selectedClient.neighborhood || '';

    if (bairro && distances) {
      const findLocality = distances.filter(item =>
        item.district.toLowerCase().includes(bairro.toLowerCase()),
      );

      if (findLocality.length > 0) {
        setSelectedClientDistance(findLocality[0]);
      }
    }
  }, [distances, selectedClient]);

  const tablesBusy = useMemo(() => {
    return orderTables.map(item => item.table_name);
  }, [orderTables]);

  const parseClients = useMemo(() => {
    let count = 0;
    const items = [...clients];

    const filter = items.filter(client => {
      const result =
        clearFormatPhoneNumber(client.whatsapp).includes(search) ||
        client.name.toLowerCase().includes(search.toLowerCase());

      if (result && count < 10) {
        count += 1;
        return true;
      }

      return false;
    });

    const tmp = filter.map(item => ({
      value: item.uid,
      label: `${item.name} | ${clearFormatPhoneNumber(item.whatsapp)}`,
    }));
    return [{ value: '', label: 'Selecione um cliente...' }, ...tmp];
  }, [clients, search]);

  const countProducts = useMemo(() => {
    let count = 0;

    products.forEach(product => {
      count += product.quantity;
    });

    return count;
  }, [products]);

  const handleOnChangeClient = useCallback(
    data => {
      // setPhoneNumber(data.value);
      const findClient = clients.find(item => item.uid === data.value);
      if (findClient) {
        console.log({ findClient });
        setSelectedClient(findClient);
      }
    },
    [clients, setSelectedClient],
  );

  const handleOnChangeTable = useCallback(
    event => {
      if (event.target.value) {
        const tableId = event.target.value;
        const findTable = tables.find(item => item.uid === tableId);
        if (findTable) {
          setTableSelected(findTable);
        }
      }
    },
    [setTableSelected, tables],
  );

  useEffect(() => {
    if (newClient && newClient.uid) {
      const findClient = clients.find(item => item.uid === newClient.uid);
      if (findClient) {
        setSelectedClient(findClient);
      }
    }
  }, [newClient, clients, setSelectedClient]);

  useEffect(() => {
    setInitTable(true);
    if (!initTable) loadTables();
  }, [loadTables, initTable]);

  const handleCreateClient = (inputValue: string) => {
    setPhoneNumber(inputValue);
  };

  function searchClients(value: string) {
    setSearch(value);
  }

  return (
    <>
      <Container open={openModalCart}>
        <TabsContainer>
          <Tabs>
            <TabItem active>
              <strong>CARRINHO</strong>
            </TabItem>
            {/* <TabItem></TabItem>
          <TabItem></TabItem> */}
          </Tabs>

          <div className="d-flex justify-content-between">
            <div className="w-100" style={{ marginRight: 8 }}>
              <label className="m-0" htmlFor="client-select">
                Cliente
              </label>

              <Select
                value={
                  newClient
                    ? {
                        value: newClient?.uid,
                        label: `${newClient?.name} | ${newClient?.whatsapp}`,
                      }
                    : selectedClient.uid
                    ? {
                        value: selectedClient?.uid,
                        label: `${selectedClient?.name} | ${selectedClient?.whatsapp}`,
                      }
                    : null
                }
                inputId="search-input"
                options={parseClients}
                onChange={handleOnChangeClient}
                placeholder="Selecione..."
                onInputChange={value => searchClients(value)}
                createOptionPosition="first"
                onCreateOption={handleCreateClient}
              />
            </div>
            <div>
              <label className="m-0" htmlFor="client-select">
                Mesa
              </label>
              <select
                id="select-table"
                className="form-control"
                onChange={handleOnChangeTable}
                value={tableSelected.uid}
                style={{ minWidth: 100, height: 38, borderColor: '#cccccc' }}
              >
                <option value="">Selecione...</option>
                {tables.map(item => (
                  <option value={item.uid}>
                    {`${item.name} ${
                      tablesBusy.includes(item.name) ? '- Ocupada' : ''
                    }`}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {toggleAddres ? (
            <div
              role="button"
              className="mt-1"
              onClick={() => setToggleAddres(false)}
            >
              Mostrar Endereço
            </div>
          ) : (
            <>
              {selectedClient.address && (
                <div
                  role="button"
                  className="mt-1"
                  onClick={() => setToggleAddres(true)}
                >
                  {`${getAddressClientPOS(selectedClient)}`}
                  <br />
                  {`Taxa de entrega: ${getCurrencyFormatted(
                    selectedClientDistance.value ?? 0,
                  )}`}
                </div>
              )}
            </>
          )}

          <PauseOrderButton />

          <Cart />
        </TabsContainer>
      </Container>

      <CartFloatButton onClick={() => setOpenModalCart(true)}>
        <i className="fas fa-shopping-cart" />
        {countProducts > 0 && <span>{countProducts}</span>}
      </CartFloatButton>

      <Overlay open={openModalCart} onClick={() => setOpenModalCart(false)} />

      <ClientFormModal
        show={!!phoneNumber}
        parameter={phoneNumber}
        onClose={() => setPhoneNumber('')}
      />

      {/* {!!phoneNumber && (
        <ModalClientForm
          phoneNumber={phoneNumber}
          onClose={() => setPhoneNumber('')}
        />
      )} */}
    </>
  );
};

export default OrderDetails;
